module.exports = __webpack_public_path__ + "c979205eb75ba286a326deba6cba06fb.jpg";